<template>
  <div>
    <el-tabs v-model="activeName">
      <el-tab-pane name="LegalHousePlanUnit" label="第三方管理计划">
        <LegalHousePlanUnit v-if="activeName==='LegalHousePlanUnit'" :urge_type="3" />
      </el-tab-pane>
      <el-tab-pane name="LegalHousePlanTemp" label="互转计划">
        <LegalHousePlanTempExcel @onAdd="handleAdd" v-if="activeName==='LegalHousePlanTemp'" :age_type_ids="[3,4]" :default_urge_type="3" :is_show_flow="true" :is_show_sync="false" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import LegalHousePlanUnit from "../plan/LegalHousePlanUnit";
import LegalHousePlan from "../plan/LegalHousePlan";
import LegalHousePlanTempExcel from "../plan/LegalHousePlanTempExcel";
import LegalHousePlanTemp from "../plan/LegalHousePlanTemp";
import LossLegalHousePlan from "../plan/LossLegalHousePlan";
import ButlerHttp from "../../common/ButlerHttp";
import {CommonHelp} from "../../common/CommonHelp";

export default {
  name: "ThirdpartyLayout",
  inject:['where','reginWhere'],
  components: {LegalHousePlanUnit, LegalHousePlan, LegalHousePlanTempExcel,LegalHousePlanTemp, LossLegalHousePlan},
  data() {
    return {
      activeName: "LegalHousePlanUnit",
      legal_house_obj: {
        total: 0,
        total2: 0,
        count: 0,
        count2: 0,
      },
    };
  },
  mounted() {
    // this.handleAdd();
  },
  methods: {
    handleAdd(){
      const that = this;
      let where = {
        project_ids:typeof that.reginWhere.project_ids==="string"?that.reginWhere.project_ids:'',
        project_id:that.reginWhere.project_name,
        area_id:that.reginWhere.area_id
      }
      ButlerHttp.post("HouseUrgeTempLog/getLegalHouseCount",where,res=>{
        console.log(res.data)
        that.legal_house_obj = res.data;
      })
    }
  },
  watch:{
    "reginWhere.type_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        // that.handleAdd();
      },500,that);
    },
    "reginWhere.project_region":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        // that.handleAdd();
      },500,that);
    },
    "reginWhere.project_name":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        // that.handleAdd();
      },500,that);
    },
    "reginWhere.area_id":function (n,o) {
      const that=this;
      CommonHelp.debounce(function () {
        // that.handleAdd();
      },500,that);
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Butler/components/thirdparty/ThirdpartyLayout.vue